export default class AbstractObserver {
  constructor(element) {
    this.element = element;
    this.defaultState = true;
  }

  reinit() {
    this.destroy().init().check();
  }
}
